import { Modal } from "components";
import { ModalBody, Box } from "@chakra-ui/react";
import { FC } from "react";
import { StripeElements } from 'components/stripe';
import { useBilling } from "lib/hooks";
import { path } from "ramda";
import { has } from "ramda";

type Props = {
  isOpen: boolean;
  onClose: () => void;
}

const getPlanStatus = path(['plan', 'status']);
const hasPaymentMethod = has('payment_method');

export const UpdateBillingDetailsModal: FC<Props> = ({ isOpen, onClose }) => {
  const { data } = useBilling();
  const status = getPlanStatus(data);

  const upgrading = !hasPaymentMethod(data) && !!data;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={upgrading ? 'Upgrade your Packs plan' : 'Update Billing Details'}>
      <ModalBody paddingBottom={5}>
        {upgrading && (
          <>
            <Box pb="20px">
              We’re so glad you’re loving Packs! 😊 
            </Box>
            <Box pb="20px">
              Upgrade to the next tier up for just $10/team member/month. (You won’t be charged until your team’s free trial runs out.)
            </Box>
            <Box>
              Enter your payment details below:
            </Box>
          </>
        )}
        <StripeElements onSuccess={onClose} submitText={"Update Card"} />
      </ModalBody>
    </Modal>
  );
}
